<script>

import {diff_match_patch} from '@/plugins/google/diff_match_patch'

export default {
    name: "VDialogDiff",
    props: {
        maxWidth: {
            default: '750px',
        },
    },
    inheritAttrs: false,
    data() {
        return {
            x: '',
            y: '',
            html: null,
            isShow: false,
            isResolved: true,
            isSubmit: false,
            isValid: false,
            data: null,
            result: false,
        };
    },
    mounted: function () {
    },
    methods: {
        show(x, y) {
            this.x = (x || '').toString();
            this.y = (y || '').toString();

            let diffs = diff_match_patch.diff_main(this.x, this.y)
            diff_match_patch.diff_cleanupSemantic(diffs)

            this.html = '<div>' + diff_match_patch.diff_prettyHtml(diffs);
            // for (let diff of diffs) {
            //     diff[1] = diff[1].replace(/\n/g, '<br/>')
            //
            //     if (diff[0] === DIFF_EQUAL) {
            //         this.html += '<span class="equal">' + diff[1] + '</span>'
            //     }
            //     if (diff[0] === DIFF_DELETE) {
            //         this.html += '<del>' + diff[1] + '</del>'
            //     }
            //     if (diff[0] === DIFF_INSERT) {
            //         this.html += '<ins>' + diff[1] + '</ins>'
            //     }
            // }
            this.html += '</div>'

            this.isShow = true;
            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
        close() {
            this.isShow = false;
        },
    },
}
</script>

<template>
    <v-dialog
        v-if="isShow"
        v-model="isShow"
        :max-width="maxWidth"
        scrollable
    >
        <v-card>
            <v-card-title>Текстовое различие</v-card-title>

            <v-card-text v-html="html"></v-card-text>

            <v-card-actions>
                <slot name="actions">
                    <v-spacer></v-spacer>
                    <v-btn @click="close()">
                        Ок
                    </v-btn>
                </slot>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<style scoped lang="css">
del, ins {
    //text-decoration-thickness: 2px;
    text-decoration-skip-ink: none;
}

del {
    background-color: #ffe6e6 !important;
    text-decoration: underline;
    text-decoration-color: red;
}

ins {
    background-color: #e6ffe6 !important;
    //text-decoration-line: underline;
    //text-decoration-color: lightgreen;
}

</style>
